export default {
	"ShareModal.ShareTips": "Share tips",
	"ShareModal.ShareWithFriends": "Share with friends",
	"ShareModal.ClickTheOneInTheTopRightCorner": "Click the one in the top right corner",
	"ShareModal.buttonToShare": "button to share.",
	"ShareModal.GenerateAPoster": "Generate a poster",
	"ShareModal.ClickTheGeneratePosterButtonToSaveThePosterImage": "Click the Generate Poster button to save the poster image."
}